import { Routes, Route, Navigate } from 'react-router-dom';
import { isAuthenticated } from './api/client';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ApiKeys from './pages/ApiKeys';
import Logs from './pages/Logs';
import Conversations from './pages/Conversations';
import Settings from './pages/Settings';
import Devices from './pages/Devices';
// Image generation pages
import ImageDashboard from './pages/image/ImageDashboard';
import ImageKeys from './pages/image/ImageKeys';
import ImageBackends from './pages/image/ImageBackends';
import ImageLogs from './pages/image/ImageLogs';
import R2Gallery from './pages/image/R2Gallery';
import Workflows from './pages/image/Workflows';
import WorkflowEditor from './pages/image/WorkflowEditor';
import TransformLogs from './pages/image/TransformLogs';
import CostAnalysis from './pages/CostAnalysis';
// Feedback page
import Feedback from './pages/Feedback';
// Content filter
import ContentBlocklist from './pages/ContentBlocklist';
// Diagnostics (MetricKit)
import Diagnostics from './pages/Diagnostics';
import AppHealth from './pages/AppHealth';
// Web search admin
import SearchBackends from './pages/SearchBackends';
import SearchLogs from './pages/SearchLogs';
// Image-captioning user uploads gallery
import UploadsGallery from './pages/uploads/UploadsGallery';
// Credit pages
import CreditsOverview from './pages/credits/Overview';
import CreditsUsers from './pages/credits/Users';
import CreditsGrant from './pages/credits/Grant';
import CreditsGenerations from './pages/credits/Generations';
import CreditsConfig from './pages/credits/Config';
import CreditsPurchases from './pages/credits/Purchases';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        {/* Text Generation Routes */}
        <Route index element={<Dashboard />} />
        <Route path="keys" element={<ApiKeys />} />
        <Route path="logs" element={<Logs />} />
        <Route path="conversations" element={<Conversations />} />
        <Route path="settings" element={<Settings />} />
        <Route path="devices" element={<Devices />} />

        {/* Cost Analysis */}
        <Route path="cost-analysis" element={<CostAnalysis />} />

        {/* Feedback */}
        <Route path="feedback" element={<Feedback />} />

        {/* Content Filter */}
        <Route path="blocklist" element={<ContentBlocklist />} />

        {/* Diagnostics (MetricKit) */}
        <Route path="diagnostics" element={<Diagnostics />} />
        <Route path="app-health" element={<AppHealth />} />

        {/* Web Search admin (under Text nav group) */}
        <Route path="search/backends" element={<SearchBackends />} />
        <Route path="search/logs" element={<SearchLogs />} />

        {/* Image-captioning user uploads gallery (under Text nav group) */}
        <Route path="uploads" element={<UploadsGallery />} />

        {/* Credit System Routes */}
        <Route path="credits" element={<CreditsOverview />} />
        <Route path="credits/users" element={<CreditsUsers />} />
        <Route path="credits/grant" element={<CreditsGrant />} />
        <Route path="credits/generations" element={<CreditsGenerations />} />
        <Route path="credits/config" element={<CreditsConfig />} />
        <Route path="credits/purchases" element={<CreditsPurchases />} />

        {/* Image Generation Routes */}
        <Route path="image" element={<ImageDashboard />} />
        <Route path="image/keys" element={<ImageKeys />} />
        <Route path="image/backends" element={<ImageBackends />} />
        <Route path="image/logs" element={<ImageLogs />} />
        <Route path="image/gallery" element={<R2Gallery />} />
        <Route path="image/workflows" element={<Workflows />} />
        <Route path="image/workflows/:id" element={<WorkflowEditor />} />
        <Route path="image/transforms" element={<TransformLogs />} />
      </Route>
    </Routes>
  );
}

export default App;
